import React from "react";

export const FieldLabel = ({label, mb = true}) => {
    return label ? <label className={"block text-left text-gray-700 text-sm font-bold"}>
        {label}
    </label> : null;
}
